import React from "react";
import { twMerge } from "tailwind-merge";
import { Badge, BadgeProps } from "./Badge";

export const PendingBadge = (
  props: BadgeProps & { children: string },
): React.ReactElement => (
  <Badge
    {...props}
    icon={"TIMER_SAND_EMPTY"}
    className={twMerge("bg-orange-100 text-orange-800", props.className)}
  >
    {props.children}
  </Badge>
);
